// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.optionsList_Series {
    position: absolute;

    list-style: none outside none;
    margin-left: 0%;
    padding-left: 0em;
    text-indent: -0.5em;
    letter-spacing: 0.05em;

    height: fit-content;
    width: 100%;

    text-align: -moz-center;
}

.optionsListItem_Series {
    /* color: black; */

    width: 100%;

    line-height: inherit;


    color: rgb(97, 97, 97);

    white-space: pre-wrap;

    justify-self: center;
    text-align: center;

    text-transform: uppercase;
}

.optionsListItem_Series_3Stack {
    font: 5.05cqh MyriadPro-Semi;
}

.optionsListItem_Series_4Stack {
    font: 6.55cqh MyriadPro-Semi;
}`, "",{"version":3,"sources":["webpack://./src/components/SeriesDescriptions.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;;IAElB,6BAA6B;IAC7B,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;;IAEtB,mBAAmB;IACnB,WAAW;;IAEX,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;;IAElB,WAAW;;IAEX,oBAAoB;;;IAGpB,sBAAsB;;IAEtB,qBAAqB;;IAErB,oBAAoB;IACpB,kBAAkB;;IAElB,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC","sourcesContent":[".optionsList_Series {\r\n    position: absolute;\r\n\r\n    list-style: none outside none;\r\n    margin-left: 0%;\r\n    padding-left: 0em;\r\n    text-indent: -0.5em;\r\n    letter-spacing: 0.05em;\r\n\r\n    height: fit-content;\r\n    width: 100%;\r\n\r\n    text-align: -moz-center;\r\n}\r\n\r\n.optionsListItem_Series {\r\n    /* color: black; */\r\n\r\n    width: 100%;\r\n\r\n    line-height: inherit;\r\n\r\n\r\n    color: rgb(97, 97, 97);\r\n\r\n    white-space: pre-wrap;\r\n\r\n    justify-self: center;\r\n    text-align: center;\r\n\r\n    text-transform: uppercase;\r\n}\r\n\r\n.optionsListItem_Series_3Stack {\r\n    font: 5.05cqh MyriadPro-Semi;\r\n}\r\n\r\n.optionsListItem_Series_4Stack {\r\n    font: 6.55cqh MyriadPro-Semi;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
